import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgWashFaceGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M34.88 27.88c-2.31-2.3-2.32-3.61-2.35-5.59-.02-1.55-.04-3.48-1.16-6.3C28.63 9.04 20.19 8 15.4 8c-.41 0-.75.34-.75.75s.34.75.75.75c4.41 0 12.16.91 14.58 7.03 1.02 2.57 1.04 4.27 1.05 5.77.02 2.1.05 3.91 2.79 6.64.35.35.48.56.53.67-.19.11-.62.22-.86.29-.75.2-1.67.45-1.8 1.31-.03.24-.01.55.02 1.01.09 1.34.25 3.82-1.04 5.2-.67.72-1.71 1.08-3.08 1.08h-.99c-1.4 0-2.72.01-3.93-.06a.75.75 0 1 0-.08 1.5c.97.05 1.99.07 3.07.07h1.94c1.8 0 3.21-.52 4.18-1.56 1.74-1.85 1.54-4.76 1.44-6.33-.01-.19-.03-.41-.03-.56.17-.08.49-.16.7-.22.77-.21 1.73-.46 1.96-1.33.22-.83-.45-1.62-.97-2.13Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M22.58 32.68c0-1.83-1.49-3.32-3.32-3.32-1.62 0-2.97 1.17-3.26 2.71-1.71.37-3 1.9-3 3.72 0 2.09 1.7 3.79 3.79 3.79s3.79-1.7 3.79-3.79c0-.02-.01-.04-.01-.06 1.2-.52 2.01-1.72 2.01-3.05Zm-5.79 5.4c-1.26 0-2.29-1.03-2.29-2.29s1.03-2.29 2.29-2.29 2.29 1.03 2.29 2.29a2.29 2.29 0 0 1-2.29 2.29Zm3.44-3.87a3.819 3.819 0 0 0-2.67-2.14c.25-.7.92-1.21 1.71-1.21 1 0 1.82.82 1.82 1.82-.01.64-.34 1.2-.86 1.53ZM15.37 29.79c1.31 0 2.37-1.06 2.37-2.37s-1.06-2.37-2.37-2.37S13 26.11 13 27.42s1.06 2.37 2.37 2.37Zm0-3.24a.87.87 0 1 1-.001 1.741.87.87 0 0 1 .001-1.741Z",
    fill: "currentColor"
  }));
}

export { SvgWashFaceGlyphSecondary as default };
